import TouchRipple from '@material-ui/core/ButtonBase/TouchRipple';
import { Conversa as ConversaDuvida } from 'api/Assessor/duvidas';
import MensagensContext from 'pages/Assessor/MensagensAssessor/Context';
import React, { useContext, useMemo, useRef } from 'react';
import { formatCPFOrCNPJ } from 'helpers/utils/cpfCnpjMask';
import { clsx } from 'helpers/utils/HTMLUtils';

import './styles.scss';
const rootClassName = 'conversa-assessor-card';

export default function Conversa({
  cpfUsuario,
  duvidas,
  nome,
}: ConversaDuvida) {
  const rippleRef = useRef() as any;
  const { conversaAtual, irParaConversa } = useContext(MensagensContext);
  const isPendente = useMemo(
    () => duvidas.some((duvida) => !duvida.resposta),
    [duvidas]
  );
  const hasResponse = useMemo(
    () => duvidas.some((duvida) => duvida.flgEmResposta),
    [duvidas]
  );

  const statusClass = useMemo(() => {
    if (isPendente && !hasResponse) {
      return 'pendente';
    } else if (hasResponse) {
      return 'em-resposta ';
    } else {
      return 'respondido';
    }
  }, [isPendente, hasResponse]);

  const isActive: any = useMemo(() => {
    return conversaAtual?.cpfUsuario === cpfUsuario &&
      isPendente &&
      !hasResponse
      ? 'ativo-pendente'
      : conversaAtual?.cpfUsuario === cpfUsuario && hasResponse
      ? 'ativo-em-resposta'
      : conversaAtual?.cpfUsuario === cpfUsuario
      ? 'ativo'
      : undefined;
  }, [conversaAtual, cpfUsuario, hasResponse, isPendente]);

  const cpf = useMemo(() => {
    const formattedCPF = formatCPFOrCNPJ(cpfUsuario || '', true);
    return typeof formattedCPF === 'string' && formattedCPF.length > 0
      ? formattedCPF
      : null;
  }, [cpfUsuario]);

  return (
    <div
      className={clsx([`${rootClassName}`, isActive])}
      onMouseDown={(e) => {
        rippleRef?.current?.start(e);
      }}
      onMouseUp={(e) => {
        rippleRef?.current?.stop(e);
      }}
      onMouseLeave={(e) => {
        rippleRef?.current?.stop(e);
      }}
    >
      <div
        className={clsx([`${rootClassName}-item`, statusClass])}
        onClick={() => {
          irParaConversa(cpfUsuario);
        }}
      >
        <span className={`${rootClassName}-associado`}>{nome}</span>
        <span className={`${rootClassName}-cpf`}>CPF {cpf}</span>
      </div>
      <TouchRipple ref={rippleRef} />
    </div>
  );
}
